import { render, staticRenderFns } from "./AccountDetail.vue?vue&type=template&id=61357953"
import script from "./AccountDetail.vue?vue&type=script&lang=ts"
export * from "./AccountDetail.vue?vue&type=script&lang=ts"
import style0 from "./AccountDetail.vue?vue&type=style&index=0&id=61357953&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports